<div class="pie-chart-report" *ngIf="!isLoading && results">
  <div class="pie-chart-report__header" *ngIf="title">
    <span class="pie-chart-report__header__title">{{ title }}</span>
  </div>

  <div class="pie-chart-report__body" [ngClass]="{ 'legend-right': legendPosition === 'right' }">
    <ngx-charts-pie-chart
      *ngIf="results.length && totalValue > 0"
      [view]="view"
      [scheme]="schemePieColor"
      [results]="results"
      [tooltipText]="formatTooltip"
    >
    </ngx-charts-pie-chart>

    <div class="pie-chart-report__body__legend" *ngIf="results.length && totalValue > 0">
      <div class="legend" *ngFor="let data of results; let i = index">
        <span class="legend__color" [ngStyle]="{ background: labelColorDomain[i] }"></span>
        <span class="legend__name">{{ data.name }}</span>
        <div class="legend__value" *ngIf="data.value !== null && data.value !== undefined">
          : {{ data.value }} ({{ data.percentage }}%)
        </div>
      </div>
    </div>

    <p class="pie-chart-report__no-results" *ngIf="!results.length || !totalValue">
      {{ 'PIE_CHART.NO_DATA' | translate }}
    </p>
  </div>
</div>

<!-- SKELETON-LOADER -->

<div class="pie-chart-report" *ngIf="isLoading">
  <div class="pie-chart-report__header">
    <ngx-skeleton-loader
      *ngIf="title"
      [theme]="{ height: '18px', width: view[0] + 'px', 'margin-bottom': '0px' }"
    ></ngx-skeleton-loader>
  </div>

  <div class="pie-chart-report__body">
    <ngx-skeleton-loader
      appearance="circle"
      [theme]="{ height: '170px', width: '170px', 'margin-bottom': '0px', 'margin-top': '0px' }"
    ></ngx-skeleton-loader>

    <div class="pie-chart-report__body__legend">
      <div class="legend">
        <ngx-skeleton-loader
          [theme]="{ height: '18px', width: view[0] + 'px', 'margin-top': '20px', 'margin-bottom': '0px' }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>

<!-- /SKELETON-LOADER -->
